import { render } from "./UiKeyPressProps.vue?vue&type=template&id=3e5e21cb"
import script from "./UiKeyPressProps.vue?vue&type=script&lang=js"
export * from "./UiKeyPressProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__